module.exports = __webpack_public_path__ + "img/record_send.477922cf.png";